import { Controller } from "@hotwired/stimulus";
import { useIntersection, useMutation } from "stimulus-use";

export default class extends Controller {
  appear(entry: MutationRecord): void {
    this.scrollIntoView(entry.target as Element);
  }

  connect(): void {
    useIntersection(this);
    useMutation(this, { attributes: true, childList: true, subtree: true });
  }

  mutate(entries: MutationRecord[]): void {
    for (const entry of entries) {
      this.scrollIntoView(entry.target as Element);
    }
  }

  scrollIntoView(el: Element): void {
    el.scrollTop = el.scrollHeight - el.clientHeight;
  }
}
